var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-step-layout", {
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.questions.goals.mortgageGoal"
                        )
                      ) +
                      "\n    "
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  !_vm.hideFlowQuestions
                    ? _c(
                        "page-section-group-layout",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          _vm.$t(
                                            "application-standalone.questions.goals.firstFlowSelection"
                                          )
                                        ) +
                                        "\n        "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2734392446
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      value: _vm.flowSelection,
                                      options:
                                        _vm.conditionalFirstFlowSelectionOptions,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.flowSelection = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showSecondFlowSelection && !_vm.hideFlowQuestions
                    ? _c(
                        "page-section-group-layout",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          _vm.$t(
                                            "application-standalone.questions.goals.secondFlowSelection"
                                          )
                                        ) +
                                        "\n        "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3580715540
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("radio-field", {
                                    attrs: {
                                      value: _vm.flowSelection,
                                      options: _vm.secondFlowSelectionOptions,
                                    },
                                    on: {
                                      "update:value": function ($event) {
                                        _vm.flowSelection = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flowSelectionMade
                    ? [
                        _vm.propertyAddressVisible
                          ? _c(
                              "page-section-group-layout",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "application-standalone.questions.goals.propertyAddress",
                                                  {
                                                    goal: _vm.goal,
                                                  }
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                          _vm.getValidator(
                                            "propertyAddress.required"
                                          )
                                            ? _c("input-required-indicator")
                                            : _vm._e(),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1548024743
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("address-field-group", {
                                          ref: "addressFieldComponent",
                                          attrs: {
                                            line1: _vm.propertyAddress.line1,
                                            line2: _vm.propertyAddress.line2,
                                            "unit-number":
                                              _vm.propertyAddress[
                                                "unit-number"
                                              ],
                                            province:
                                              _vm.propertyAddress.province,
                                            city: _vm.propertyAddress.city,
                                            "postal-code":
                                              _vm.propertyAddress[
                                                "postal-code"
                                              ],
                                            "street-direction":
                                              _vm.propertyAddress[
                                                "street-direction"
                                              ],
                                            "street-name":
                                              _vm.propertyAddress[
                                                "street-name"
                                              ],
                                            "street-number":
                                              _vm.propertyAddress[
                                                "street-number"
                                              ],
                                            "street-type":
                                              _vm.propertyAddress[
                                                "street-type"
                                              ],
                                            "time-at":
                                              _vm.propertyAddress["time-at"],
                                            validator:
                                              _vm.getValidator(
                                                "propertyAddress"
                                              ),
                                            label: _vm.$t(
                                              "application-form.address"
                                            ),
                                            "hidden-label": "",
                                            "show-required-indicator": "",
                                          },
                                          on: {
                                            "update:line1": function ($event) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "line1",
                                                $event
                                              )
                                            },
                                            "update:line2": function ($event) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "line2",
                                                $event
                                              )
                                            },
                                            "update:unitNumber": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "unit-number",
                                                $event
                                              )
                                            },
                                            "update:unit-number": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "unit-number",
                                                $event
                                              )
                                            },
                                            "update:province": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "province",
                                                $event
                                              )
                                            },
                                            "update:city": function ($event) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "city",
                                                $event
                                              )
                                            },
                                            "update:postalCode": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "postal-code",
                                                $event
                                              )
                                            },
                                            "update:postal-code": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "postal-code",
                                                $event
                                              )
                                            },
                                            "update:streetDirection": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "street-direction",
                                                $event
                                              )
                                            },
                                            "update:street-direction":
                                              function ($event) {
                                                return _vm.$set(
                                                  _vm.propertyAddress,
                                                  "street-direction",
                                                  $event
                                                )
                                              },
                                            "update:streetName": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "street-name",
                                                $event
                                              )
                                            },
                                            "update:street-name": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "street-name",
                                                $event
                                              )
                                            },
                                            "update:streetNumber": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "street-number",
                                                $event
                                              )
                                            },
                                            "update:street-number": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "street-number",
                                                $event
                                              )
                                            },
                                            "update:streetType": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "street-type",
                                                $event
                                              )
                                            },
                                            "update:street-type": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "street-type",
                                                $event
                                              )
                                            },
                                            "update:timeAt": function ($event) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "time-at",
                                                $event
                                              )
                                            },
                                            "update:time-at": function (
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.propertyAddress,
                                                "time-at",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.propertyAddressProvinceVisible
                          ? _c(
                              "page-section-group-layout",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "application-standalone.questions.goals.propertyAddressProvince"
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                          _vm.getValidator(
                                            "propertyDetailsAddressProvince.required"
                                          )
                                            ? _c("input-required-indicator")
                                            : _vm._e(),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  883892138
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("select-field", {
                                          attrs: {
                                            value:
                                              _vm.propertyDetailsAddressProvince,
                                            label: _vm.$t(
                                              "global.words.province"
                                            ),
                                            placeholder: _vm.$t(
                                              "global.words.province"
                                            ),
                                            options: _vm.canadaProvinceOptions,
                                            validator: _vm.getValidator(
                                              "propertyDetailsAddressProvince"
                                            ),
                                          },
                                          on: {
                                            "update:value": function ($event) {
                                              _vm.propertyDetailsAddressProvince =
                                                $event
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.propertyDetailsPurchasePriceVisible
                          ? _c(
                              "page-section-group-layout",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.isPreApprovalSelected
                                                  ? _vm.$t(
                                                      "application-standalone.questions.goals.purchasePriceNewProperty"
                                                    )
                                                  : _vm.$t(
                                                      "application-standalone.questions.goals.purchasePrice"
                                                    )
                                              ) +
                                              "\n            "
                                          ),
                                          _vm.getValidator(
                                            "propertyDetailsPurchasePrice.required"
                                          )
                                            ? _c("input-required-indicator")
                                            : _vm._e(),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2096340608
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("currency-field", {
                                          attrs: {
                                            value:
                                              _vm.propertyDetailsPurchasePrice,
                                            validator: _vm.getValidator(
                                              "propertyDetailsPurchasePrice"
                                            ),
                                            label: _vm.isPreApprovalSelected
                                              ? _vm.$t(
                                                  "application-standalone.questions.goals.purchasePriceNewProperty"
                                                )
                                              : _vm.$t(
                                                  "application-standalone.questions.goals.purchasePrice"
                                                ),
                                            "hidden-label": "",
                                          },
                                          on: {
                                            "update:value": function ($event) {
                                              _vm.propertyDetailsPurchasePrice =
                                                $event
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mortgageDetailsDownpaymentAmountVisible
                          ? _c(
                              "page-section-group-layout",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "application-standalone.questions.goals.downPaymentConsidered"
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                          _vm.getValidator(
                                            "mortgageDetailsDownpaymentAmount.required"
                                          )
                                            ? _c("input-required-indicator")
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              attrs: {
                                                id: "downPaymentTooltipTarget",
                                              },
                                            },
                                            [
                                              _c("icon", {
                                                staticClass:
                                                  "text-primary small clickable ml-1",
                                                attrs: { name: "info-circle" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("notification-popover", {
                                            attrs: {
                                              target:
                                                "downPaymentTooltipTarget",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "popoverContent",
                                                  fn: function () {
                                                    return [
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.$t(
                                                              "application-standalone.pages.goals.downPayment"
                                                            )
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1848962997
                                            ),
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  448476299
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("currency-field", {
                                          attrs: {
                                            value:
                                              _vm.mortgageDetailsDownpaymentAmount,
                                            label:
                                              _vm.propertyDetailsPurchasePriceVisible
                                                ? _vm.$t(
                                                    "application-form.amount"
                                                  )
                                                : "",
                                            validator: _vm.getValidator(
                                              "mortgageDetailsDownpaymentAmount"
                                            ),
                                          },
                                          on: {
                                            "update:value": function ($event) {
                                              _vm.mortgageDetailsDownpaymentAmount =
                                                $event
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.propertyDetailsPurchasePriceVisible
                                      ? _c(
                                          "b-col",
                                          [
                                            _c("percentage-field", {
                                              attrs: {
                                                digits: 2,
                                                value:
                                                  _vm.downPaymentPercentage,
                                                label: _vm.$t(
                                                  "application-standalone.labels.percentage"
                                                ),
                                              },
                                              on: {
                                                "update:value": function (
                                                  $event
                                                ) {
                                                  _vm.downPaymentPercentage =
                                                    $event
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.mortgageDetailsClosingDateVisible
                          ? _c(
                              "page-section-group-layout",
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function () {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.closingDateQuestion
                                                ) +
                                                "\n            "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm.getValidator(
                                            "mortgageDetailsClosingDate.required"
                                          )
                                            ? _c("input-required-indicator")
                                            : _vm._e(),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2401327453
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("date-field", {
                                          attrs: {
                                            value:
                                              _vm.mortgageDetailsClosingDate,
                                            validator: _vm.getValidator(
                                              "mortgageDetailsClosingDate"
                                            ),
                                            label: _vm.$t("global.words.date"),
                                            "hidden-label": "",
                                          },
                                          on: {
                                            "update:value": function ($event) {
                                              _vm.mortgageDetailsClosingDate =
                                                $event
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "navigation",
              fn: function () {
                return [
                  _vm._t("navigation-toolbar", null, null, {
                    handleNavigateNext: _vm.handleNavigateNext,
                    handleNavigateBack: _vm.handleNavigateBack,
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }